import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";

import { summariseItem } from "../../helpers/comparison";
import APIcon from "../buttons/APIcon";
import { ComparisonCriterion } from "./APComparison";

type APComparisonSummaryProps<T> = {
  selectedItem: T;
  items: T[];
  criteria: Partial<Record<keyof T, ComparisonCriterion<T>>>;
  summaryCriteria: (keyof T)[];
  criteriaLabelMap: Record<keyof T, string>;
};

const APComparisonSummary = <T,>({
  selectedItem,
  items,
  criteria,
  summaryCriteria,
  criteriaLabelMap,
}: APComparisonSummaryProps<T>) => {
  const renderSummaryItem = (status: "win" | "loss", criteriaId: keyof T) => {
    const statusIcon = status === "win" ? "trophy" : "close";
    return (
      <Box
        key={String(criteriaId)}
        sx={{ display: "flex", alignItems: "center", columnGap: 0.5 }}
      >
        <Box
          sx={{
            display: "flex",
            width: "20px",
            height: "20px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <APIcon
            name={statusIcon}
            color={status === "win" ? "tertiaryGreen" : "error"}
            size="small"
          />
        </Box>
        <Typography variant="labelXSmall">
          {criteriaLabelMap[criteriaId]}
        </Typography>
      </Box>
    );
  };

  const renderedSummaryMap: Record<"win" | "loss", ReactNode[]> = {
    win: [],
    loss: [],
  };

  const summary = summariseItem(selectedItem, items, criteria, summaryCriteria);

  summary.win.forEach((criteriaId) => {
    const item = renderSummaryItem("win", criteriaId);
    renderedSummaryMap.win.push(item);
  });
  summary.loss.forEach((criteriaId) => {
    const item = renderSummaryItem("loss", criteriaId);
    renderedSummaryMap.loss.push(item);
  });

  return (
    <Box>
      {renderedSummaryMap.win}
      {renderedSummaryMap.loss}
    </Box>
  );
};

export default APComparisonSummary;
